import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { toHypenatedLowerCase } from '../../helpers/stringHelpers'
import classnames from 'classnames'
import { forEach } from 'lodash'

import './AZStoreList.scss'

class AZStoreList extends PureComponent {
  constructor () {
    super()
    this.storesList = {
      A: [],
      B: [],
      C: [],
      D: [],
      E: [],
      F: [],
      G: [],
      H: [],
      I: [],
      J: [],
      K: [],
      L: [],
      M: [],
      N: [],
      O: [],
      P: [],
      Q: [],
      R: [],
      S: [],
      T: [],
      U: [],
      V: [],
      W: [],
      X: [],
      Y: [],
      Z: []
    }
    this.getListHeadings = this.getListHeadings.bind(this)
    this.getListPanels = this.getListPanels.bind(this)
  }

  componentDidMount () {
    for (const x in this.props.stores) {
      if (this.props.stores[x].legacy_name === 'store 2' || this.props.stores[x].legacy_name === 'store name') return // hack for mock data
      this.storesList[this.props.stores[x].legacy_name.charAt(0)] =
        this.storesList[this.props.stores[x].legacy_name.charAt(0)] || []
      this.storesList[this.props.stores[x].legacy_name.charAt(0)].push(this.props.stores[x])
    }
  }

  getListHeadings () {
    const letters = []
    forEach(this.storesList, (value, key) => {
      if (this.storesList[key].length === 0) return
      letters.push(
        <li key={key}>
          <a
            className='azsl-btn'
            data-el={'stores-list-az-heading-' + key}
            href={'#storeslist-' + key}
            tabIndex={this.props.visible ? '0' : '-1'}
          >
            {key}
          </a>
        </li>
      )
    })
    return letters
  }
  getListPanels () {
    const panels = []
    forEach(this.storesList, (value, storekey) => {
      if (this.storesList[storekey].length === 0) return
      const list = []
      const listStyle = {
        height: this.storesList[storekey].length * 11.2 + 'px'
      }
      forEach(this.storesList[storekey], (value, key) => {
        list.push(
          <li key={key} className='azsl-list-item'>
            <a
              data-el={'stores-list-az-store-' + storekey + '-' + key}
              className='azsl-link'
              href={'/stores/' + value.store_id + '-' + toHypenatedLowerCase(value.legacy_name)}
            >
              {value.legacy_name}
            </a>
          </li>
        )
      })
      panels.push(
        <div className='azsl-panel' key={storekey}>
          <span className='azsl-info-letter'>{storekey}</span>
          <ul className='azsl-stores' id={'storeslist-' + storekey} style={listStyle}>
            {list}
          </ul>
        </div>
      )
    })
    return panels
  }
  render () {
    const listHeadings = this.getListHeadings()
    const listPanels = this.getListPanels()
    const listClassNames = classnames('azsl-wrapper', { visible: this.props.visible })
    const chevronClassNames = classnames('argos-icon', {
      ' icon-UIE-Controls-Chevron-Down': !this.props.visible,
      ' icon-UIE-Controls-Chevron-Up': this.props.visible
    })
    return (
      <div className='az-store-list container' id='storeslist'>
        <button className='btn-see-all-stores' onClick={e => this.props.toggleVisible(!this.props.visible)}>
          See all stores <span className={chevronClassNames} />
        </button>
        <div className={listClassNames}>
          <ol className='azsl-az-lists'>{listHeadings}</ol>
          {listPanels}
        </div>
      </div>
    )
  }
}

AZStoreList.defaultProps = {
  visible: true,
  stores: []
}

AZStoreList.propTypes = {
  visible: PropTypes.bool,
  toggleVisible: PropTypes.func,
  stores: PropTypes.array
}

export default AZStoreList



// WEBPACK FOOTER //
// ./src/components/AZStoreList/AZStoreList.jsx